import React from 'react';
import { object, func, PropTypes } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { Formik, Form } from 'formik';
import { withStyles } from '@material-ui/core/styles';

import { trustValidationSchema, validateFilesLength } from './validationSchema';

import CompositeAlert from '../../core/CompositeAlert';
import Fieldset from '../../core/Fieldset';
import AbnSearch from '../../abn/abnsearch/AbnSearch';
import StepContainer from '../steps/StepContainer';
import DeedFileForm from '../../deedfileform/DeedFileForm';

const styles = (theme) => ({
  form: {
    margin: theme.spacing(2, 0),
  },
});

class LocateYourTrust extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleBusinessSelection = this.handleBusinessSelection.bind(this);
  }

  componentDidMount() {
    this.props.resetValidationResult();
  }

  handleBusinessSelection(data) {
    this.props.isEligible(data);
  }

  render() {
    const {
      classes,
      validationResult,
      submitTrustDetails,
      resetValidationResult,
      errorMessage,
      searchTrust,
      delay,
    } = this.props;
    return (
      <Formik
        initialValues={{ files: [] }}
        validateOnBlur={false}
        validationSchema={trustValidationSchema(this.props)}
        onSubmit={(values, { setSubmitting }) => {
          const callback = () => {
            setSubmitting(false);
          };
          submitTrustDetails(values, callback);
        }}
        render={({ values, errors, touched, handleSubmit, isSubmitting }) => {
          const filesLengthError = validateFilesLength(values.files);
          return (
            <StepContainer
              title="Locate your trust"
              subtitle="Find and select the ABN of your trust"
              isSubmitVisible={validationResult.isEligible}
              isSubmitDisabled={
                isSubmitting || !validationResult.isEligible || Object.keys(errors).length > 0
              }
              onSubmit={handleSubmit}
            >
              <Form autoComplete="off">
                <Fieldset disabled={isSubmitting}>
                  <Grid container spacing={2}>
                    {errorMessage && (
                      <Grid item xs={12}>
                        <CompositeAlert variant="error" message={errorMessage} />
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <AbnSearch
                        onItemSelected={this.handleBusinessSelection}
                        onNewSearch={resetValidationResult}
                        search={searchTrust}
                        data-testid="abnsearch"
                        delay={delay}
                      />
                    </Grid>
                    {(validationResult?.isValidated ?? false) && (
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs={12}>
                            <CompositeAlert
                              variant={validationResult.isEligible ? 'success' : 'error'}
                              message={validationResult.message}
                            />
                          </Grid>
                          <Grid item xs={12} className={classes.form}>
                            <DeedFileForm
                              name="files"
                              values={values}
                              errors={errors}
                              touched={touched}
                              data-testid="deedFileForm"
                              filesLengthError={filesLengthError}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Fieldset>
              </Form>
            </StepContainer>
          );
        }}
      />
    );
  }
}

LocateYourTrust.propTypes = {
  classes: object,
  validationResult: object.isRequired,
  isEligible: func.isRequired,
  resetValidationResult: func.isRequired,
  submitTrustDetails: func.isRequired,
  errorMessage: PropTypes.string,
  searchTrust: PropTypes.func.isRequired,
  delay: PropTypes.number,
};

LocateYourTrust.defaultProps = {
  classes: {},
  errorMessage: '',
  delay: 500,
};

export default withStyles(styles)(LocateYourTrust);
